<div class="wl-timeline">
  <!-- Skeleton del Gantt: columna de etiquetas + carril, con las barras a anchos distintos para
       que se lea como un diagrama y no como una lista. -->
  <div class="sk-gantt" *ngIf="loading" aria-busy="true" aria-label="Cargando la línea de tiempo">
    <div class="sk-g-head">
      <p-skeleton height="0.8rem" width="9rem"></p-skeleton>
      <p-skeleton height="0.8rem" width="14rem"></p-skeleton>
    </div>
    <div class="sk-g-row" *ngFor="let i of [1,2,3,4,5,6,7]" [ngClass]="'sk-fade-' + (i > 4 ? 4 : i)">
      <div class="sk-g-label">
        <p-skeleton height="0.8rem" [width]="i % 2 === 0 ? '11rem' : '8rem'"></p-skeleton>
        <p-skeleton height="0.6rem" width="5rem"></p-skeleton>
      </div>
      <div class="sk-g-track">
        <p-skeleton height="20px" [width]="[38, 62, 25, 74, 46, 55, 33][i - 1] + '%'" borderRadius="6px"
          [style]="{ 'margin-left': [4, 18, 40, 8, 26, 12, 34][i - 1] + '%' }"></p-skeleton>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!loading">
    <!-- El sprint da el marco temporal; el Gantt dibuja sobre fechas reales, que lo desbordan. -->
    <div class="wl-tl-head" *ngIf="sprint">
      <span class="wl-tl-sprint"><i class="fa-solid fa-flag"></i> Sprint {{ sprint.number }}</span>
      <span class="wl-tl-window">
        {{ sprint.startDate | date: 'dd MMM' }} → <strong>{{ sprint.endDate | date: 'dd MMM' }}</strong> · entrega del sprint
      </span>
      <span class="wl-tl-count">duración real de cada implementación</span>
    </div>

    <app-worklog-gantt
      [epics]="epics"
      [loose]="loose"
      [sprintEnd]="sprint?.endDate ?? null"
      (openItem)="openItem.emit($event)"
      (select)="openEpic.emit($event)"></app-worklog-gantt>
  </ng-container>
</div>
